export default __webpack_public_path__ + "static/media/mission-vissioncard1.2be49ec0.svg";